import React from "react";
import { Button, Card, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import UnififedSearch from "./search";

const destinationCard = (title, desc, dest) => (
  <Card style={{ width: "18rem", margin: "20px" }} border="primary">
    <Card.Body className="text-center p-16">
      <Card.Title className="h1">{title}</Card.Title>
      <br />
      <Card.Text>{desc}</Card.Text>
      <br />
      <Button as={Link} to={dest} variant="primary" block>
        Visit
      </Button>
    </Card.Body>
  </Card>
);
const Home = () => {
  return (
    <div>
      <Helmet>
        <title>{`Covid Resources 21`}</title>
        <meta
          name="description"
          content={`Covid Resources 21 is a community-based Covid-resources
            portal for India where strangers help strangers by
            contributing, verifying and searching for Covid resources, depending
            on one's circumstances`}
        />
      </Helmet>
      <Container
        className="bg-white"
        style={{ marginTop: "50px", marginBottom: "50px" }}
      >
        <h2 className="display-4">Covid Resources 21</h2>
        <p className="font-weight-normal">
          Welcome to Covid Resources 21, a community-based Covid-resources
          portal for <em>India</em> where strangers help strangers by
          contributing, verifying and searching for Covid resources, depending
          on one’s circumstances. Thank you for being a part of this community.
        </p>
      </Container>
      <Container>
        <UnififedSearch />
      </Container>
      <Container style={{ marginTop: "50px", marginBottom: "50px" }}>
        <Row className="d-flex mb-4 justify-content-center">
          {destinationCard(
            "Location Resources",
            "State and Union Territories based Covid resources",
            "location-resources"
          )}
          {destinationCard(
            "Live Bed Tracker",
            "State and Union Territories based verfied bed tracking resources",
            "track"
          )}
          {destinationCard(
            "Important Links",
            "Important Pan-India key Covid resources",
            "key-resources"
          )}
          {destinationCard(
            "Home Therapy",
            "Remedies to help those recuperating at home",
            "remedies"
          )}
        </Row>
      </Container>
    </div>
  );
};

export default Home;
